<template>
  <div>
<!--    <div v-if="!info.takeNo" class="noOrder">暂无订单</div>-->
<!--    v-else-->
    <div>
<!--      <div class="orderBox">-->
<!--        <img class="bg" src="../assets/bg.png">-->
<!--        <img class="xue" src="../assets/order.png">-->
<!--        <div class="takNo" v-if="info.isRefund != 1">-->
<!--          <p>凭取餐码自提：{{ info.takeNo }}</p>-->
<!--          <p>门店已接单，请于下单当日及时到店取餐</p>-->
<!--        </div>-->
<!--        <div v-else class="takNo">-->
<!--          <p>已退单</p>-->
<!--          <p>订单金额已原路返回，请及时查看</p>-->
<!--        </div>-->
<!--      </div>-->

      <div class="home">

        <div class="shopBox takNoBox">
          <div class="takNo" v-if="info.isRefund != 1 && info.orderStatus !== 10 && !info.cancelType" style="display: flex;justify-content: center;align-items: center;">
            <img src="../assets/coffee_bean.png">
            <p class="takNo-Num">{{ info.takeNo }}</p>
          </div>
          <div v-else-if="info.orderStatus === 10" class="takNo">
            <p style="text-align: center;font-size: 19px;font-weight: 600">待支付</p>
            <div class="orderBtn">
              <el-button type="primary" @click="cancelOrder" style="background-color: #FFFFFF;border-color:#F5F5F5;color: #000000">取消订单</el-button>
              <el-button type="primary" @click="toAliUrl" style="background-color: #E60012;border-color:#E60012;">确认支付</el-button>
<!--              ali跳转之前是payOrder-->
            </div>
<!--            <p style="text-align: center;font-size: 14px">订单金额已原路返回，请及时查看</p>-->
          </div>
          <div v-else-if="info.cancelType">
            <p style="text-align: center;font-size: 19px;font-weight: 600">订单已取消</p>
            <p style="text-align: center;font-size: 14px">期待您的光临</p>
          </div>
          <div v-else class="takNo">
            <p style="text-align: center;font-size: 19px;font-weight: 600">已退单</p>
            <p style="text-align: center;font-size: 14px">订单金额已原路返回，请及时查看</p>
          </div>
        </div>

        <div class="shopBox" style="margin-bottom: 20px">
          <div>
            <p style="font-size: 17px;font-weight: 500">{{ info.shopName }}</p>
            <P class="font_L" style="margin:5px 0;font-size: 13px">{{ info.shopAddress }}</P>
          </div>
        </div>

        <div class="shopBox">

          <div class="product border_btm">
            <img :src="info.productLogo">
            <!--                <image v-else :src="errImg" mode="aspectFit" style="width: 100px;height: 120px;"></image> -->

            <div class="detail">
              <div class="flex-ad">
                <p style="font-size: 15px">{{ info.productName }}</p>
                <p style="font-size: 15px;font-weight: 500">￥{{ info.productPrice / 100 }}</p>
              </div>
              <p class="font_L" style="font-size: 12px">
                {{
                  info.attributeName
                }}</p>
              <div class="flex-ad" style="font-size: 13px">
                <p>×{{ info.productAmount }}</p>
              </div>
            </div>
          </div>

          <div class="juanSec border_btm" v-if="type != 10">
            <p class="font_L">优惠券</p>
            <p style="color: #F12734">-￥{{ info.productPrice / 100 }}</p>
          </div>

          <div class="btm" v-if=" type != 10">
            <p style="text-align: right;font-size: 14px">共1件，合计<span
                style="font-size: 17px;font-weight: 600">￥{{ info.realPrice / 100 }}</span></p>
          </div>

          <div class="btm" v-if=" type == 10">
            <p style="text-align: right;font-size: 14px">共1件商品，应付<span
                style="font-size: 17px;font-weight: 600">￥{{ info.productPrice / 100 }}</span></p>
          </div>


        </div>

        <div class="shopBox" style="margin-top: 20px">
          <div class="item">
            <p>下单时间</p>
            <p class="right">{{ info.orderTime }}</p>
          </div>
          <div class="item">
            <p>订单编号</p>
            <p class="right">{{ info.orderId }}</p>
          </div>

          <div class="item" v-if="info.takeNo">
            <p>取餐号码</p>
            <p class="right">{{ info.takeNo }}</p>
          </div>
<!--          <div class="item">-->
<!--            <p>是否打包</p>-->
<!--            <p class="right">要打包袋</p>-->
<!--          </div>-->
          <div class="item">
            <p>备注</p>
            <p class="right">{{ !info.remark ? '无' : info.remark }}</p>
          </div>
<!--          <div class="item">-->
<!--            <p>门店编码</p>-->
<!--            <p class="right">{{ info.shopCode }}</p>-->
<!--          </div>-->
          <div class="item">
            <p>手机号</p>
            <p class="right">{{ info.mobilePhone }}</p>
          </div>
        </div>

      </div>
    </div>



    <el-dialog
        :visible.sync="showDialog"
        title="下单中"
        width="60%"
        :close-on-click-modal="false"
    >
      <span>{{loadingText}}</span>
      <template #footer>
        <el-button
            type="primary"
            @click="showDialog = false"
            :loading="loading"
        >
          {{ loading ? '支付中...' : '确认' }}
        </el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import {cancelOrder, payOrder, queryOrder,getAliUrl} from "@/api/mxbc";

export default {
  name: 'orderInfo',
  data() {
    return {
      info: {},
      orderId:'',
      type:1,
      showDialog: false,
      loading: true,
      loadingText: '正在下单中，请稍等',
      orderFlag: false,
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.query.cardID) {
          this.cardID = this.$route.query.cardID
          localStorage.setItem('cardID', this.cardID);
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.$route.query.cardID) {
      this.cardID = this.$route.query.cardID
      localStorage.setItem('cardID', this.cardID);
    }
    if (!localStorage.getItem('cardID')) return this.$message.error('未复制完整卡密链接')
    this.orderId = localStorage.getItem('orderID');
    this.type = localStorage.getItem('type');
    this.getOrder();
  },
  methods: {
    getOrder() {
      queryOrder({cardID: localStorage.getItem('cardID'),orderCode:this.orderId}).then(res => {
        if (res.code !== 0) return
        this.info = res.data
        //console.log(res, '订单查询返回')
      }).catch(err=>{
        this.$message.error('查询失败,请刷新重试')
      })
    },
    cancelOrder(){
      cancelOrder({cardID: localStorage.getItem('cardID'),orderCode:this.orderId}).then(res => {
        if (res.code === 0){
          this.$message.success(res.msg)
          this.getOrder();
        }
      }).catch(err=>{
        this.$message.error('查询失败,请刷新重试')
      })
    },
    payOrder(){
      if (this.orderFlag) return
      this.loadingText = '正在下单中，请稍等'
      this.orderFlag = true
      this.showDialog = true

      try {
        payOrder({cardID: localStorage.getItem('cardID'),orderCode:this.orderId}).then(res => {
          if (res.code === 0){
            this.$message.success(res.msg)
            this.getOrder();
          }
        })
      }catch(err){
        this.handleOrderError()
      }finally {
        this.cleanupOrder()
      }
    },
    handleOrderError() {
      this.loadingText = '下单失败，请联系管理员'
      this.$message.error('下单失败，请联系管理员')
    },

    cleanupOrder() {
      this.loading = false
      this.dialogVisible = false
      this.orderFlag = false
    },

    toAliUrl(){
      getAliUrl({cardID:localStorage.getItem('cardID')}).then(res => {
        if (res.code === 0){
          window.location.href=res.data
        }else{
          this.$message.error(res.msg)
        }
      })
    },
  },

}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: calc(100vh);
  padding-top: 10px;
  background-color: #F5F5F5;
  margin: -10px 0 0 0;
  border-radius: 10px 10px 0 0;
  position: relative;
}

.takNoBox{
  margin: 20px auto !important;
}

.takNo {
  //color: #FFFFFF;
  //max-width: 55vw;
  z-index: 2;
  img{
    width: 26px;
    height: 26px;
  }
  .takNo-Num {
    font-size: 2.5rem;
    text-align: center;
    color: #E60012;
    font-weight: bold;
    margin-bottom: 10px;
    //line-height: 1.2;
    //word-break: break-all;
  }
}


.shopBox {
  width: 85%;
  margin: 0 auto;
  padding: 15px;
  background-color: #FFFFFF;
  border-radius: 10px;
  //z-index: 666;
  //height: 300px;
}

.product {
  height: 66px;
  padding: 10px 0;
  display: flex;
  flex-direction: row;

  img {
    //width: 90px;
    //height: 80px;
    //margin-right: 15px;
    //object-fit: cover;
    //border-radius: 10px;

    border-radius: 6px;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    height: 66px;
    margin-right: 11px;
    position: relative;
    width: 66px;
  }

  .detail {
    height: 100%;
    width: calc(100% - 77px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

}

.payInfo {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.juanSec {
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.flex-ad {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btm {
  margin-top: 20px;
}


.item {
  display: flex;
  margin: 15px 0;
}

.item p:first-child{
  min-width: 80px;
  margin-right: 10px;
  color: #999999;
}

.right {
  color: #606060;
}



.juan {
  font-size: 14px;
  border: 1px solid #842A43;
  color: #842A43;
  padding: 3px 5px;
}


.font_L {
  font-size: 13px;
  color: #999999;
}

.border_btm {
  border-bottom: 1px dashed #999999;
}

.noOrder{
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.orderBtn{
  margin: 10px 0;
  display: flex;
  justify-content: center;
}

/deep/ .el-dialog {
  margin-top: 30vh !important;
}

</style>